import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateClassBookingCountService=async(data)=>{
    try {
        const result = await publicPost(`api/class_booking_count/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateClassBookingCountService=async(data,id)=>{
    try {
        const result = await put(`api/class_booking_count/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetClassBookingCountService=async()=>{
    try {
        const result = await get(`api/class_booking_count/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteClassBookingCountService=async(id)=>{
    try {
        const result = await deleteRequest(`api/class_booking_count/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

